import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type OnSignInChangedSubscriptionVariables = Types.Exact<{ [key: string]: never; }>;


export type OnSignInChangedSubscription = { __typename?: 'Subscription', signInChanged: boolean };


export const OnSignInChanged = /*#__PURE__*/ gql`
    subscription OnSignInChanged {
  signInChanged
}
    ` as unknown as DocumentNode<OnSignInChangedSubscription, OnSignInChangedSubscriptionVariables>;

          

          export const useOnSignInChangedSubscription = (options?:SubscriptionHookOptions<OnSignInChangedSubscription, OnSignInChangedSubscriptionVariables>) => useSubscription(OnSignInChanged, options);

          

          export type OnSignInChangedSubscriptionOptions = SubscriptionHookOptions<OnSignInChangedSubscription, OnSignInChangedSubscriptionVariables>;

          

          export type OnSignInChangedSubscriptionResult = ReturnType<typeof useOnSignInChangedSubscription>;

          
